import { createAction, props } from '@ngrx/store';
import { Platform } from '@ridango/core';

export const openOsNotificationSettings = createAction('[Permissions] Open OS Notification Settings');
export const openOsNotificationSettingsError = createAction(
    '[Permissions] Open OS Notification Settings Error',
    props<{ error: Error }>()
);
export const loadNotificationsChannels = createAction(
    '[Permissions] Load Notifications Channels',
    props<{ channels: any }>()
);
export const updateNotificationsChannelsRequest = createAction(
    '[Permissions] Update Notifications Channels Request',
    props<{ channels: any }>()
);
export const updateNotificationsChannelsSuccess = createAction(
    '[Permissions] Update Notifications Channels',
    props<{ channels: any }>()
);
export const updateNotificationsChannelsError = createAction(
    '[Permissions] Notifications Channels Error',
    props<{ error: Error }>()
);
export const determinePlatform = createAction('[Permissions] Determine Platform');
export const determinePlatformSuccess = createAction('[Permissions] Set Platform', props<{ platform: Platform }>());
export const determineNativePlatformSuccess = createAction('[Permissions] Set Native Platform Success');
export const determinePlatformError = createAction(
    '[Permissions] Determine Platform Error',
    props<{ error: string }>()
);
export const pushNotificationAddListeners = createAction('[Permissions] Add Push Notification Listeners');
export const pushNotificationCheckPermission = createAction('[Permissions] Check Notification Permission');
export const pushNotificationTokenReceived = createAction('[Permissions] Token Received', props<{ token: string }>());
export const pushNotificationTokenStored = createAction('[Permissions] Token Stored', props<{ token: string }>());
export const pushNotificationReceived = createAction(
    '[Permissions] Notification Received',
    props<{ notification: any }>()
);
export const pushNotificationError = createAction('[Permissions] Error', props<{ error: Error | string }>());
export const pushNotificationActionPerformed = createAction(
    '[Permissions] Push Notification Action Performed',
    props<{ notification: any }>()
);
export const sendToken = createAction('[Permissions] Send Token');
export const sendTokenSuccess = createAction('[Permissions] Send Token Success', props<{ token: string }>());
export const sendTokenFailure = createAction('[Permissions] Send Token Failure', props<{ error: Error }>());
export const pushNotificationListenersAdded = createAction('[Permissions] Push Notification Listeners Added');
export const pushNotificationListenersRemoved = createAction('[Permissions] Push Notification Listeners Removed');
export const afterLoginSuccess = createAction('[Permissions] After Login Success');
export const afterLogoutSuccess = createAction('[Permissions] After Logout Success');
